import axios from 'axios'
import qs from 'qs'
import { clone, roundXDecimals, objectSnakeToCamelCase, objectCamelToSnakeCase, getWorkingDays, removeEmpty } from '@/util/libUtil.js'
import defaultObjetivoForm from '@/util/areaPersonal/defaultObjetivoForm'
import defaultCorrectiveFactor from '@/util/areaPersonal/defaultCorrectiveFactor'
import defaultTeam from '@/util/areaPersonal/defaultTeam'

const state = {
    objetivo: [],
    objetivoComercial: [],
    objetivoRaw: [],

    teamForm: {
        form: clone(defaultTeam),
        isOpen: false,
        isOpenTeamCreate: false,
        isOpenTeamView: false,
        isLoading: false,
        duttyManagerId: null,
        teams: []
    },

    isOpenAddBadgeDialog: false,
    isOpenSummaryBadgeTable: false,
    isOpenSummaryCorrectiveFactor: false,

    selectedComercial: null,
    bolsaComercial: null,
    factor_corrector: [],
    reward: null,
    correctiveFactors: [],
    isLoadingCorrectiveFactors: false,

    upfrontTable: {
        upfronts: [], //Contiene una lista con las cuentas que se ven en la tabla.
        totalEntries: 0,
        isLoading: false,
        page: 1,
        params: {}
    },
    badges: [],
    isLoadingBadges: false,
    tipo_objetivo: [],
    ofertaHtml: '',
    isLoadingObjetivos: false,
    isLoadingCopyObjetives: false,
    isLoadingUpfronts: false,
    maxPorcentaje: 150,
    searchOfferTable: '',
    factorView: {
        isOpenViewFactor: false,
        factor: null
    },
    correctiveFactor: {
        isOpen: false,
        form: clone(defaultCorrectiveFactor),
    },
    objetivoForm: {
        father: '',
        isAlreadyUpdated: false,
        isOpen: false,
        isEditing: false,
        isLoading: false,
        form: clone(defaultObjetivoForm),
    },
    dateAtencionForm: {
        isOpen: false,
        isOpenView: false,
        isEditing: false,
        isLoading: false,
        form: {
            updatedOn: null
        }
    },
    isLoadingOfertas: false,
    date: new Date(),
    dateActualInmutable: new Date(new Date().toISOString().substr(0, 7)),
    actualTab: 1,
    paths: {
        objetivoOrigPath: '/api/calculadora/objetivo/',
        objetivoPath: '/api/calculadora/objetivo_mes/',
        bolsaPath: '/api/calculadora/bolsa_mes/',
        factorCorrectorPath: '/api/calculadora/factorcorrector/',
        teamsPath: '/api/cuentas/teams/',
        upfrontPath: '/api/servicios/upfronts/',
        tipoObjetivoPath: '/api/servicios/tipoobjetivo/',
        getOfertasPath: '/api/atenciones/oferta/',
        getAtencionesPath: '/api/atenciones/entradas/',
        getHtmlOfertaPath: '/api/utils/generate-oferta-html/',
        copyObjetivesNextMonthPath: '/api/calculadora/copy-objetivos-next-month/',
        getXLSX: '/api/calculadora/download-xlsx-calculadora/',
        rewardTypePath: '/api/calculadora/reward/',
    }
}

const mutations = {
    objetivoGeneric(state, { data, nameMutation, getters }) {
        let val = clone(data)
        getters.definePropertyObjetivos(val)
        state[nameMutation] = val
    },

    objetivoComercial(state, val) {
        state.objetivoComercial = clone(val)
    },
    objetivoRaw: (state, val) => {
        state.objetivoRaw = clone(val)
    },
    objetivo(state, val) {
        state.objetivo = clone(val)
    },
    factor_corrector: (state, val) => {
        val = clone(val)
        val.forEach(obj => {
            Object.defineProperty(obj, "factor_corrector_name", {
                get: function () {
                    let signo_porcentaje = (obj.porcentaje_maximo >= 999) ? `> ${val[val.length - 2].porcentaje_maximo}` : `< ${obj.porcentaje_maximo}`
                    return `${signo_porcentaje}%`

                },
                set: function () { }
            });
        })
        // Sort by porcentaje maximo

        state.factor_corrector = val
    },
    upfronts: (state, val) => {
        state.upfrontTable.totalEntries = val.count
        state.upfrontTable.upfronts = val.results
    },
    tableUpfrontPage: (state, val) => {
        state.upfrontTable.page = val
    },
    tableTableParams(state, val) {
        state.upfrontTable.params = val
    },
    isOpenSummaryCorrectiveFactor: (state, val) => {
        state.isOpenSummaryCorrectiveFactor = val
    },
    isOpenSummaryTeams: (state, val) => {
        state.teamForm.isOpen = val
    },
    teamsForm: (state, val) => {
        state.teamForm.form = clone(val)
    },
    isOpenCorrectiveFactor: (state, val) => {
        state.correctiveFactor.isOpen = val
    },
    correctiveFactor: (state, val) => {
        state.correctiveFactor.form = clone(val)
    },
    isOpenSummaryBadgeTable: (state, val) => {
        state.isOpenSummaryBadgeTable = val
    },
    isOpenAddBadgeDialog: (state, val) => {
        state.isOpenAddBadgeDialog = val
    },
    isOpenViewFactor: (state, val) => {
        state.factorView.isOpenViewFactor = val
    },
    factorView: (state, val) => {
        state.factorView.factor = clone(val)
    },
    teamToView: (state, val) => {
        state.teamForm.teamToView = clone(val)
    },
    tipo_objetivo: (state, val) => {
        state.tipo_objetivo = val
    },
    correctiveFactors: (state, val) => {
        state.correctiveFactors = clone(val)
    },
    teams: (state, val) => {
        state.teamForm.teams = clone(val)
    },
    badges: (state, val) => {
        state.badges = clone(val)
    },
    date: (state, val) => {
        state.date = val
    },
    actualTab: (state, val) => {
        state.actualTab = val
    },
    ofertaHtml: (state, val) => {
        state.ofertaHtml = val
    },
    selectedComercial: (state, val) => {
        state.selectedComercial = val
    },
    searchOfferTable: (state, val) => {
        state.searchOfferTable = val
    },
    isLoadingCopyObjetives: (state, val) => {
        state.isLoadingCopyObjetives = val
    },
    isOpenDialogObjetivo: (state, val) => {
        state.objetivoForm.isOpen = val
    },
    isEditingObjetivo: (state, val) => {
        state.objetivoForm.isEditing = val
    },
    isLoadingFormObjetivo: (state, val) => {
        state.objetivoForm.isLoading = val
    },
    objetivoForm: (state, val) => {
        state.objetivoForm.form = val
    },
    isLoadingObjetivos: (state, val) => {
        state.isLoadingObjetivos = val
    },
    isLoadingAtencion: (state, val) => {
        state.dateAtencionForm.isLoading = val
    },
    isOpenDialogAtencion: (state, val) => {
        state.dateAtencionForm.isOpen = val
    },
    isEditingAtencion: (state, val) => {
        state.dateAtencionForm.isEditing = val
    },
    dateAtencionForm: (state, val) => {
        state.dateAtencionForm.form = val
    },
    dateAtencion: (state, val) => {
        state.dateAtencionForm = val
    },
    dateAtencionIsAlreadyUpdated: (state, val) => {
        state.dateAtencionForm.isAlreadyUpdated = val
    },
    duttyManagerId: (state, val) => {
        state.teamForm.duttyManagerId = val
    },
    isOpenTeamCreate: (state, val) => {
        state.teamForm.isOpenTeamCreate = val
    },
    isOpenTeamView: (state, val) => {
        state.teamForm.isOpenTeamView = val
    },
    bolsaComercial: (state, val) => {
        state.bolsaComercial = clone(val)
    },
    isLoadingOfertas: (state, val) => {
        state.isLoadingOfertas = val
    },
    isLoadingUpfronts: (state, val) => {
        state.isLoadingUpfronts = val
    },
    isLoadingCorrectiveFactors: (state, val) => {
        state.isLoadingCorrectiveFactors = val
    },
    isLoadingTeams: (state, val) => {
        state.teamForm.isLoading = val
    },
    isLoadingBadges: (state, val) => {
        state.isLoadingBadges = val
    },
    reward: (state, val) => {
        state.reward = val
    }
}

const actions = {
    setObjetives({ commit, getters }, { data, nameMutation }) {
        commit(nameMutation, { data, nameMutation, getters })
    },
    async addBadge({ state, getters, dispatch, commit }, params) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.rewardTypePath), params)
            dispatch('getBadge', {
                is_active: true
            })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Bonificación añadida!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al introducir bonificación',
            }, { root: true })
        }
    },
    async getBadge({ state, getters, dispatch, commit }, params) {
        try {
            commit('isLoadingBadges', true);
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.rewardTypePath), {
                params
            })
            commit('badges', resp.data)
            commit('isLoadingBadges', false);
        } catch {
            commit('isLoadingBadges', false);
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener las bonificaciones',
            }, { root: true })
        }
    },
    async deleteBadge({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.rewardTypePath)}${id}/`)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "¡Bonificación eliminada!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al borrar la bonificación',
            }, { root: true })
        }
    },
    async addTeam({ state, getters, dispatch, commit }, params) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.teamsPath), state.teamForm.form)
            dispatch('getTeams', {
                is_active: true
            })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "¡Equipo añadido!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al introducir equipo',
            }, { root: true })
        }
    },
    async addCorrectiveFactor({ state, getters, dispatch, commit }, params) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.factorCorrectorPath), state.correctiveFactor.form)
            dispatch('getCorrectiveFactors', {
                is_active: true
            })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "¡Factor corrector añadido!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al introducir factor corrector',
            }, { root: true })
        }
    },
    async getCorrectiveFactors({ state, getters, dispatch, commit }, params) {
        try {
            commit('isLoadingCorrectiveFactors', true);
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.factorCorrectorPath), {
                params
            })
            commit('correctiveFactors', resp.data)
            commit('isLoadingCorrectiveFactors', false);
        } catch {
            commit('isLoadingCorrectiveFactors', false);
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener factores correctores',
            }, { root: true })
        }
    },
    async getTeams({ state, getters, dispatch, commit }, params) {
        try {
            commit('isLoadingTeams', true);
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.teamsPath), {
                params
            })
            commit('teams', resp.data)
            commit('isLoadingTeams', false);
        } catch {
            commit('isLoadingTeams', false);
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener los equipos',
            }, { root: true })
        }
    },
    async fetchRewardType({ state, getters, dispatch, commit }, params) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.rewardTypePath), { params })
            commit('reward', resp.data)
        } catch (err) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: `Error al obtener el tipo de recompesa, el comercial no tiene tipo de recompensa`
            }, { root: true })
        }
    },
    async fetchFactorCorrector({ state, getters, dispatch, commit }, params) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.factorCorrectorPath), { params })

            resp.data[0].factor_details = Object.values(resp.data[0].factor_details)

            // Don't sort because already sorted by backend
            // resp.data[0].factofactor_correctorr_details.sort(function (a, b) {
            //     if (a.porcentaje_maximo < b.porcentaje_maximo) return -1;
            //     if (a.porcentaje_maximo > b.porcentaje_maximo) return 1;
            //     return 0;
            // })

            commit('factor_corrector', resp.data[0].factor_details)
        } catch (err) {
            commit('factor_corrector', [])
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                timeout: 5000,
                message: `Error al cargar factor corrector, posiblemente no lo tenga cargado aún, pongase en contacto con su representante`
            }, { root: true })
        }
    },
    async deleteTeam({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.teamsPath)}${id}/`)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Equipo Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Equipo',
            }, { root: true })
        }
    },
    async deleteFactor({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.factorCorrectorPath)}${id}/`)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Factor Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Factor',
            }, { root: true })
        }
    },
    exportDB({ state, dispatch }) {
        dispatch('util/exportDB', {
            path: state.paths.getXLSX,
            params: { 'month': state.date.getMonth() + 1, 'year': state.date.getFullYear() },
            title: `Calculadoras_${(state.date.getMonth() + 1) + "_" + state.date.getFullYear()}`,
        }, { root: true })
    },
    async fetchAtencion({ state, getters, dispatch, commit }, atencionId) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.getAtencionesPath) + atencionId, {
            })
            return resp.data
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener la atencion'
            }, { root: true })
        }
    },

    async fetchHtmlOffer({ state, getters, dispatch, commit }, offerId) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.getHtmlOfertaPath) + offerId, {
            })
            commit('ofertaHtml', resp.data)
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al visualizar la oferta'
            }, { root: true })
        }
    },

    async fetchObjetivo({ state, getters, dispatch, commit, rootState, rootGetters }, { comercialId, soldOut, isForm = false }) {
        if (!isForm) {
            commit('isLoadingObjetivos', true);
            commit('objetivo', [])
            commit('objetivoRaw', [])
            commit('objetivoComercial', [])
        }

        let params_process = {
            'month_year_updated_on': `${state.date.getFullYear()}-${state.date.getMonth() + 1}`,
        }
        if (comercialId) params_process['comercial'] = comercialId
        if (soldOut) params_process['sold_out'] = soldOut
        try {
            // Obtengo los objetivos
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.objetivoPath), {
                params: params_process
            })

            if (!isForm)
                commit('objetivoRaw', resp.data)

            if (rootGetters['login/hasManagerPermission']) {
                // check if has team
                const hasTeam = resp.data.some(({ comercial }) => comercial.id != state.selectedComercial?.id)
                if (isForm) {
                    commit('objetivo', resp.data)
                } else if (hasTeam) {
                    let commercialObjectives = [];
                    resp.data.forEach((element) => {
                        let index = commercialObjectives.findIndex(
                            (item) => item.familia.id === element.familia.id
                        );

                        let numItems = commercialObjectives.filter(
                            (item) => item.familia.id === element.familia.id
                        );

                        if (index === -1) {
                            let copy = clone(element);
                            if (
                                element.comercial.id !== state.selectedComercial?.id ||
                                element.comercial.id === JSON.parse(localStorage.getItem('cuenta')).id
                            )
                                copy.id = null;

                            commercialObjectives.push(copy);
                        } else {
                            if (
                                element.comercial.id === state.selectedComercial?.id ||
                                element.comercial.id === JSON.parse(localStorage.getItem('cuenta')).id
                            )
                                commercialObjectives[index].id = element.id;

                            commercialObjectives[index].peso = (
                                (parseFloat(commercialObjectives[index].peso) +
                                    parseFloat(element.peso)) /
                                (numItems.length + 1)
                            ).toFixed(2);
                            commercialObjectives[index].consecucion =
                                parseFloat(commercialObjectives[index].consecucion) +
                                parseFloat(element.consecucion);
                            commercialObjectives[index].objetivo =
                                parseFloat(commercialObjectives[index].objetivo) +
                                parseFloat(element.objetivo);
                        }
                    });
                    commit('objetivoGeneric', { data: commercialObjectives, nameMutation: 'objetivoComercial', getters })
                } else {
                    commit('objetivoGeneric', { data: resp.data, nameMutation: 'objetivoComercial', getters })
                }
            } else {
                commit('objetivoGeneric', { data: resp.data, nameMutation: 'objetivo', getters })
            }

            // Obtengo la bolsa en juego
            if (
                comercialId ||
                // rootState.login.cuenta.rol.id == rootState.general.rolesEncode.Comercial
                JSON.parse(localStorage.getItem('cuenta')).rol.id == rootState.general.rolesEncode.Comercial
            ) {
                try {
                    resp = await axios.get(getters.getEndpointFromPath(state.paths.bolsaPath), {
                        params: params_process
                    })
                    commit('bolsaComercial', resp.data)
                } catch {
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'error',
                        message: '¡Error al cargar bolsa del mes!'
                    }, { root: true })
                }
            }

        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al cargar los objetivos'
            }, { root: true })
        }

        commit('isLoadingObjetivos', false);
    },
    async fetchUpfronts({ state, getters, dispatch, commit }) {
        try {
            commit('isLoadingUpfronts', true);
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.upfrontPath), {
                params: state.upfrontTable.params,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                },
            })
            commit('upfronts', resp.data)
            commit('isLoadingUpfronts', false);
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al cargar los upfronts'
            }, { root: true })
        }
    },
    async updateUpfrontTableParams({ commit, state }, params) {
        let newParams = { ...state.upfrontTable.upfronts.params, ...params }
        newParams = removeEmpty(newParams) // eliminate nulls
        commit('tableTableParams', newParams)
    },
    async fetchTipoObjetivo({ state, getters, dispatch, commit }) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.tipoObjetivoPath), {
            })
            commit('tipo_objetivo', resp.data)
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al cargar los tipos objetivos'
            }, { root: true })
        }
    },

    fetchOfertas({ state, getters, dispatch, commit }, params) {
        return new Promise(async (resolve, reject) => {
            try {
                commit('isLoadingOfertas', true)
                let resp = await axios.get(getters.getEndpointFromPath(state.paths.getOfertasPath), {
                    params: params,
                    paramsSerializer: params => {
                        return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                    },
                })

                commit('isLoadingOfertas', false)
                resolve(objectSnakeToCamelCase(resp.data))
                // commit('ofertas', resp.data)
            } catch {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'Error al cargar las ofertas'
                }, { root: true })
                commit('isLoadingOfertas', false)
                reject('Oh no! :(')
            }
        })
    },

    fetchGestiones({ state, getters, dispatch, commit }, params) {
        return new Promise(async (resolve, reject) => {
            try {
                let resp = await axios.get(getters.getEndpointFromPath(state.paths.getAtencionesPath), {
                    params: { filtrar: 'gestiones', ...params, },
                })
                resolve(objectSnakeToCamelCase(resp.data))
                // commit('gestiones', resp.data)
            } catch {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'Error al cargar las gestiones'
                }, { root: true })

                reject('Oh no! :(')
            }
        })
    },

    async addObjetivo({ state, getters, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.objetivoOrigPath), state.objetivoForm.form)
            if (state.selectedComercial.id)
                dispatch('fetchObjetivo', { comercialId: state.selectedComercial.id })
            else
                dispatch('fetchObjetivo')

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Objetivo añadido correctamente',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                error: error,
                message: 'Error al añadir el objetivo',
            }, { root: true })
        }
        commit('isLoadingFormObjetivo', false)
    },
    async deleteObjetivo({ state, dispatch, getters, commit }) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.objetivoOrigPath) + state.objetivoForm.form.id)
            dispatch('fetchObjetivo')
            dispatch('fetchObjetivo', { comercialId: state.selectedComercial.id })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Objetivo eliminado correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
        commit('isLoadingFormObjetivo', false)
        commit('objetivoForm', clone(defaultObjetivoForm))
    },
    async deleteAtencion({ state, getters, dispatch, commit }) {
        try {
            commit('isLoadingAtencion', true)
            await axios.delete(getters.getEndpointFromPath(state.paths.getAtencionesPath) + state.dateAtencionForm.form.id + '/')
            dispatch('fetchObjetivo')
            if (state.selectedComercial) {
                dispatch('fetchObjetivo', { comercialId: state.selectedComercial.id })
            }
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Atención eliminada con éxito',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al eliminar atención',
            }, { root: true })
        }
        commit('isLoadingAtencion', false)
    },
    async updateObjetivo({ state, getters, dispatch, commit }) {
        try {
            await axios.put(getters.getEndpointFromPath(state.paths.objetivoOrigPath) + state.objetivoForm.form.id + '/', state.objetivoForm.form)
            dispatch('fetchObjetivo')
            dispatch('fetchObjetivo', { comercialId: state.selectedComercial.id })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Objetivo actualizado correctamente',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                statusType: 'error',
                message: 'Error al editar el objetivo',
            }, { root: true })
        }
        commit('isLoadingFormObjetivo', false)
    },
    async updateAtencion({ state, getters, dispatch, commit }, newDate) {
        try {
            commit('isLoadingAtencion', true)
            await axios.put(getters.getEndpointFromPath(state.paths.getAtencionesPath) + state.dateAtencionForm.form.id + '/',
                {
                    updated_on: new Date(newDate),
                })
            commit('dateAtencionIsAlreadyUpdated', true)
            dispatch('fetchObjetivo')
            if (state.selectedComercial) {
                dispatch('fetchObjetivo', { comercialId: state.selectedComercial.id })
            }
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Atención actualizada con éxito',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al editar atención',
            }, { root: true })
        }
        commit('isLoadingAtencion', false)
    },
    async updateOffer({ state, getters, dispatch }, offer) {
        try {
            await axios.put(getters.getEndpointFromPath(state.paths.getOfertasPath) + offer.id + '/', offer)
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al editar la oferta',
            }, { root: true })
        }
    },
    async copyObjetivesNextMonth({ state, getters, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.copyObjetivesNextMonthPath), { 'month': state.date.getMonth() + 1, 'year': (state.date.getFullYear()) })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: `Objetivos copiados de ${getters.currentNameMonthYear
                    } a ${getters.nextNameMonthYear}`,
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al copiar los objetivos de un mes a otro',
            }, { root: true })
        }
        commit('isLoadingCopyObjetives', false)
    }
}


const getters = {
    definePropertyObjetivos: (state, getters) => (objetivos) => {
        objetivos.forEach(obj => {
            Object.defineProperty(obj, "objetivo_porc", {
                get: function () {
                    if (obj.objetivo == 0) {
                        return ''
                    }
                    return roundXDecimals(obj.consecucion / obj.objetivo * 100, 2)
                },
                set: function () { }
            });
            Object.defineProperty(obj, "comision_porc", {
                get: function () {
                    if (obj.objetivo == 0) {
                        return 0
                    }
                    if (obj.objetivo_porc > state.maxPorcentaje) {
                        return roundXDecimals(state.maxPorcentaje * obj.peso / 100, 2)
                    } else {
                        return roundXDecimals(obj.objetivo_porc * obj.peso / 100, 2)
                    }
                },
                set: function () { }
            });
            Object.defineProperty(obj, "five_percent", {
                get: function () {
                    if (obj.objetivo == 0) {
                        return -1
                    }

                    const diasLaborablesMes = getWorkingDays(state.date);
                    let diasLaborablesHastaHoy = null;

                    if (new Date(state.date.toISOString().substr(0, 7)) < state.dateActualInmutable) {
                        diasLaborablesHastaHoy = diasLaborablesMes;
                    } else {
                        diasLaborablesHastaHoy = getWorkingDays(state.date, true);
                    }

                    const objetivoDia = obj.objetivo / diasLaborablesMes;
                    const objetivoHastaHoy = (objetivoDia * diasLaborablesHastaHoy);

                    return objetivoHastaHoy.toFixed(2);
                },
                set: function () { }
            });
        })
    },
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    getConsecucion: (state, getters, rootState, rootGetters) => {
        let objetivosValidos = rootGetters['login/hasManagerPermission'] ? state.objetivoComercial : state.objetivo

        // objetivosValidos = objetivosValidos.filter(
        //     (element) =>
        //         element.comercial.id === state.selectedComercial?.id ||
        //         element.comercial.id === objectSnakeToCamelCase(JSON.parse(localStorage.getItem('cuenta'))).id
        // );

        return roundXDecimals(objetivosValidos.reduce((acc, obj) => acc + obj.comision_porc, 0), 2)
    },
    getCostoGeneral(state, _, rootState) {
        // return (state.selectedComercial ?? rootState.login.cuenta).costoGeneral
        return (state.selectedComercial ?? JSON.parse(localStorage.getItem('cuenta'))).costoGeneral
    },
    getCorrector(state, getters) {
        let actual_consecution = getters.getConsecucion
        let factor_corrector_obj = 0;

        state.factor_corrector.some(obj => {
            if (actual_consecution < obj.porcentaje_maximo) {
                factor_corrector_obj = obj.factor_corrector
                return true
            }
            return false
        })
        return factor_corrector_obj;
    },
    getBolsaEnJuego(state, _, rootState, rootGetters) {
        if (state.bolsaComercial) {
            if (state.bolsaComercial?.reward?.reward_type === 'BOLSA_FIJA') {
                return (state.bolsaComercial.reward.amount).toFixed(2)
            } else {
                let calculateBadge = 0.00;
                if (state.bolsaComercial.reward || state.bolsaComercial.reward_recomendado) {
                    if (state.bolsaComercial.reward) {
                        calculateBadge = parseFloat(state.bolsaComercial.bolsa) * ((state.bolsaComercial.reward.amount) * 0.01).toFixed(2)
                        if (state.bolsaComercial.reward_recomendado) {
                            calculateBadge += parseFloat(state.bolsaComercial.bolsa_recomendado) * ((state.bolsaComercial.reward_recomendado.amount) * 0.01).toFixed(2)
                        }
                    }
                } else {
                    calculateBadge = (parseFloat(state.bolsaComercial.bolsa) + parseFloat(state.bolsaComercial.recomendado)).toFixed(2)
                }
                return calculateBadge;
            }
        } else {
            return 0.00
        }
        // let objetivoValid = rootGetters['login/hasManagerPermission'] ? state.objetivoComercial : state.objetivo
        // let bolsaValid = objetivoValid.filter(obj => obj.consecucion > 0)
        // return bolsaValid.reduce((acc, obj) => acc + (parseFloat(obj.upfront_definitivo) * ((comercial.porcentajeUpfront ?? comercial.porcentaje_upfront) * 0.01)), 0.00).toFixed(2)
    },
    getBolsaComercial(state, _, rootState, rootGetters) {
        if (state.bolsaComercial && state.bolsaComercial.reward) {
            if (state.bolsaComercial.reward.reward_type === 'BOLSA_FIJA') {
                return (state.bolsaComercial.reward.amount).toFixed(2)
            } else {
                return parseFloat(state.bolsaComercial.bolsa) * ((state.bolsaComercial.reward.amount) * 0.01).toFixed(2)
            }
        } else {
            return 0.00
        }
    },
    getBolsaRecomendador(state, _, rootState, rootGetters) {
        if (state.bolsaComercial && state.bolsaComercial.reward_recomendado) {
            return parseFloat(state.bolsaComercial.bolsa_recomendado) * ((state.bolsaComercial.reward_recomendado.amount) * 0.01).toFixed(2)
        } else {
            return 0.00
        }
    },
    haveCostoGeneral(state, _, rootState) {
        // let comercial = state.selectedComercial ?? objectSnakeToCamelCase(rootState.login.cuenta)
        let comercial = state.selectedComercial ?? objectSnakeToCamelCase(JSON.parse(localStorage.getItem('cuenta')))
        return comercial.costoGeneral
    },
    getBolsaEnJuegoSinPorcentaje(state, _, rootState, rootGetters) {
        // let comercial = state.selectedComercial ?? objectSnakeToCamelCase(rootState.login.cuenta)
        let comercial = state.selectedComercial ?? objectSnakeToCamelCase(JSON.parse(localStorage.getItem('cuenta')))
        if (!comercial.costoGeneral) {
            return 0.0
        }
        return parseFloat(state.bolsaComercial?.bolsa + state.bolsaComercial?.bolsa_recomendado).toFixed(2)
        // let objetivoValid = rootGetters['login/hasManagerPermission'] ? state.objetivoComercial : state.objetivo
        // let bolsaValid = objetivoValid.filter(obj => obj.consecucion > 0)
        // return bolsaValid.reduce((acc, obj) => acc + (parseFloat(obj.upfront_definitivo) * ((comercial.porcentajeUpfront ?? comercial.porcentaje_upfront) * 0.01)), 0.00).toFixed(2)
    },
    getTotalComision: (state, getters) => {
        return getters.checkLlave && !getters.checkSomeZero ? (getters.getBolsaEnJuego * getters.getCorrector).toFixed(2) : null
    },
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    objetivosConLlave: (state, getters, rootState, rootGetters) => {
        let objetivoRawWithProperty = clone(state.objetivoRaw).filter(({ llave }) => llave)
        getters.definePropertyObjetivos(objetivoRawWithProperty)
        return objetivoRawWithProperty
    },
    checkLlave: (state, getters) => (
        getters.objetivosConLlave.length != 0 ? getters.objetivosConLlave.every(({ objetivo_porc }) => objetivo_porc >= 100) : true
    ),
    checkSomeZero: (state, getters, rootState, rootGetters) => {
        let objetivoValid = (rootGetters['login/hasManagerPermission'] ? state.objetivoComercial : state.objetivo)
        return objetivoValid.filter(({ objetivo }) => objetivo > 0).some(({ consecucion }) => consecucion == 0)
    },
    thereAreObjetives: (state, getters, rootState, rootGetters) => {
        let objetivoValid = (rootGetters['login/hasManagerPermission'] ? state.objetivoComercial : state.objetivo)
        return objetivoValid.length != 0
    },
    hasTeamObjectives: (state, getters, rootState, rootGetters) => {
        let objetivoValid = (rootGetters['login/hasManagerPermission'] ? state.objetivoComercial : state.objetivo)
        return objetivoValid.some(({ comercial }) => comercial.id != state.selectedComercial?.id)
    },
    currentNameMonthYear: (state) => {
        return `${state.date.toLocaleString('es', {
            month: 'long',
            year: 'numeric',
        })}`;
    },
    nextNameMonthYear: (state) => {
        let newDate = new Date(state.date);
        newDate.setMonth(newDate.getMonth() + 1);
        return `${newDate.toLocaleString('es', {
            month: 'long',
            year: 'numeric',
        })
            }`;
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}